import { render, staticRenderFns } from "./startShare.vue?vue&type=template&id=4a764ce4&scoped=true&"
import script from "./startShare.vue?vue&type=script&lang=js&"
export * from "./startShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a764ce4",
  null
  
)

export default component.exports